import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChangeContactField = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <circle cx="9.5" cy="6.5" r="4.5" fill={getColor(color, isColorInherited)} />
    <path
      fill={getColor(color, isColorInherited)}
      d="M18 10C19.1046 8.89543 20.8954 8.89543 22 10C23.1046 11.1046 23.1046 12.8954 22 14L14.4282 21.5718C14.149 21.851 13.7934 22.0413 13.4062 22.1188L9.73544 22.8529C9.38558 22.9229 9.07711 22.6144 9.14709 22.2646L9.88124 18.5938C9.95868 18.2066 10.149 17.851 10.4282 17.5718L18 10Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0615 12.3699C12.5489 12.1321 11.9786 12 11.38 12H7.61995C5.56494 12 3.84428 13.5572 3.6398 15.602L3.2199 19.801C3.10216 20.9784 4.02673 22 5.20997 22H7.44475L8.18522 18.2976C8.35662 17.4407 8.77784 16.6536 9.3958 16.0357L13.0615 12.3699Z"
    />
  </SvgIcon>
);
